export function StatCard({ icon, label, value, valueClass = "text-white", testId, accent = false }) {
  return (
    <div
      data-testid={testId}
      className={`border ${accent ? "border-[#FF2A2A]/40 bg-[#FF2A2A]/[0.04]" : "border-white/10 bg-[#0a0a0a]"} p-6`}
    >
      <div className="flex items-center gap-2 text-[#FF2A2A] mb-3">{icon}</div>
      <div className={`font-display text-4xl font-extrabold tracking-tight ${valueClass}`}>
        {value.toLocaleString()}
      </div>
      <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-white/45">
        {label}
      </div>
    </div>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function FieldGroup({ label, children, testId }) {
  return (
    <label className="block" data-testid={testId}>
      <span className="block font-mono text-[9px] uppercase tracking-[0.22em] text-white/45 mb-1.5">
        {label}
      </span>
      {children}
    </label>
  );
}
